
import createIconComponent from '../utils/createIconComponent';
import { SVG_SAVE_OUTLINED } from '../../../dist';
import React from 'react';
const SaveOutlinedIcon = createIconComponent({ content: SVG_SAVE_OUTLINED, height: 24, width: 24 });
SaveOutlinedIcon.displayName = 'SaveOutlinedIcon';
export default SaveOutlinedIcon;
